import {
  useEffect,
  useRef,
  type RefObject
} from "react";

import type { ActivityCompletionMetrics } from "@/app/integration/contracts";

export function useCompletionReporting(
  metrics: ActivityCompletionMetrics,
  onComplete: ((metrics: ActivityCompletionMetrics) => void) | undefined
): void {
  const reportedRef = useRef(false);

  useEffect(() => {
    if (!metrics.completed) {
      reportedRef.current = false;
      return;
    }

    if (!reportedRef.current) {
      reportedRef.current = true;
      onComplete?.(metrics);
    }
  }, [metrics, onComplete]);
}

export function usePlayerFocus(
  completed: boolean,
  firstControlRef: RefObject<HTMLElement | null>,
  resultHeadingRef: RefObject<HTMLElement | null>
): void {
  const previousCompletedRef = useRef(completed);

  useEffect(() => {
    if (!previousCompletedRef.current && completed) {
      resultHeadingRef.current?.focus();
    } else if (previousCompletedRef.current && !completed) {
      firstControlRef.current?.focus();
    }

    previousCompletedRef.current = completed;
  }, [completed, firstControlRef, resultHeadingRef]);
}
